import React, { useState } from 'react';
import './BlocksUtility.css';
import * as XLSX from 'xlsx';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const BlockUtility = () => {
    const ExcelUpload = () => {
        const [excelData, setExcelData] = useState(null);

        const handleFileUpload = (e) => {
          const file = e.target.files[0];
          const reader = new FileReader();

          reader.onload = (event) => {
            const binaryString = event.target.result;
            const workbook = XLSX.read(binaryString, { type: 'binary' });
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];
            const data = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
            setExcelData(data);
            setTimeout(() => {
                toast.success("Data Uploaded successfully");
              }, 1000);
          };

          reader.readAsBinaryString(file);
        };
        const saveData = () => {
            // Simulate saving data
            setTimeout(() => {
              toast.success("Data saved successfully");
            }, 1000);
          };

        return (
          <div className='mainTable'>
            <h2>AAC Utility</h2>
            <input type="file" onChange={handleFileUpload} accept=".xlsx,.xls" />
            {excelData && (
              <div>
                <button onClick={saveData}>Save Data</button>
                {/* Apply the specified styles directly to the table */}
                <table className='table-bordered'>
                  <thead>
                    <tr>
                      {excelData[0].map((cell, index) => (
                        <th key={index}>{cell}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {excelData.slice(1).map((row, rowIndex) => (
                      <tr key={rowIndex}>
                        {row.map((cell, cellIndex) => (
                          <td key={cellIndex}>{cell}</td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
                
              </div>
            )}
          </div>
        );
      };

      return (
        <div className="App">
          <ExcelUpload />
          <ToastContainer />
        </div>
      );
};

export default BlockUtility;
